"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.license_type_groups_filter = void 0;
var license_type_groups_filter = [{
  key: 'all',
  keys: ['all', 'tutte', 'tutte'],
  slug: {
    'it': 'tutte'
  },
  label: {
    'it': 'tutte'
  },
  label_plural: {
    'it': 'tutte'
  },
  order: 0
}, {
  key: 'Strutture ricettive',
  keys: ['Strutture ricettive', 'struttura-ricettiva'],
  slug: {
    'it': 'struttura-ricettiva'
  },
  label: {
    'it': 'Strutture ricettive'
  },
  label_plural: {
    'it': 'Strutture ricettive'
  },
  order: 1
}, {
  key: 'Bar, pub e caffè',
  keys: ['Bar, pub e caffè', 'bar-pub-caffe'],
  slug: {
    'it': 'bar-pub-caffe'
  },
  label: {
    'it': 'Bar, pub e caffè'
  },
  label_plural: {
    'it': 'Bar, pub e caffè'
  },
  custom_slug: {
    'it': 'bar-pub-caffe'
  },
  order: 2
}, {
  key: 'Ristoranti e locali con cucina',
  keys: ['Ristoranti e locali con cucina', 'ristorazione'],
  slug: {
    'it': 'ristorazione'
  },
  label: {
    'it': 'Ristoranti e locali con cucina'
  },
  label_plural: {
    'it': 'Ristoranti e locali con cucina'
  },
  custom_slug: {
    'it': 'ristorazione'
  },
  order: 3
}, {
  key: 'Negozi di alimentari',
  keys: ['Negozi di alimentari', 'alimentari'],
  slug: {
    'it': 'alimentari'
  },
  label: {
    'it': 'Negozi di alimentari'
  },
  label_plural: {
    'it': 'Negozi di alimentari'
  },
  custom_slug: {
    'it': 'alimentari'
  },
  order: 4
}, {
  key: 'Tabaccheria',
  keys: ['Tabaccheria', 'tabaccheria'],
  slug: {
    'it': 'tabaccheria'
  },
  label: {
    'it': 'Tabaccheria'
  },
  label_plural: {
    'it': 'Tabaccherie'
  },
  order: 5
}, {
  key: 'Farmacia',
  keys: ['Farmacia', 'farmacia'],
  slug: {
    'it': 'farmacia'
  },
  label: {
    'it': 'Farmacia'
  },
  label_plural: {
    'it': 'Farmacie'
  },
  order: 6
}, {
  key: 'Edicola',
  keys: ['Edicola', 'edicola'],
  slug: {
    'it': 'edicola'
  },
  label: {
    'it': 'Edicola'
  },
  label_plural: {
    'it': 'Edicole'
  },
  order: 7
}, {
  key: 'Negozi di vendita al dettaglio',
  keys: ['Negozi di vendita al dettaglio', 'commercio-al-dettaglio'],
  slug: {
    'it': 'commercio-al-dettaglio'
  },
  label: {
    'it': 'Negozi di vendita al dettaglio'
  },
  label_plural: {
    'it': 'Negozi di vendita al dettaglio'
  },
  custom_slug: {
    'it': 'negozi-al-dettaglio'
  },
  order: 8
}, // {
//   key: 'Centro educativo',
//   keys: [
//     'Centro educativo',
//     'centro-educativo',
//   ],
//   slug: {
//     'it': 'centro-educativo',
//   },
//   label: {
//     'it': 'Centro educativo',
//   },
//   label_plural: {
//     'it': 'Centri educativi',
//   },
//   order: 9,
// },
{
  key: 'Centri estetici e parrucchieri',
  keys: ['Centri estetici e parrucchieri', 'estetica-e-bellezza'],
  slug: {
    'it': 'estetica-e-bellezza'
  },
  label: {
    'it': 'Centri estetici e parrucchieri'
  },
  label_plural: {
    'it': 'Centri estetici e parrucchieri'
  },
  custom_slug: {
    'it': 'cura-del-corpo'
  },
  order: 10
}, {
  key: 'Palestre',
  keys: ['Palestre', 'palestra'],
  slug: {
    'it': 'palestre'
  },
  label: {
    'it': 'Palestre'
  },
  label_plural: {
    'it': 'Palestre'
  },
  order: 11
}, {
  key: 'Servizi professionali',
  keys: ['Servizi professionali', 'servizi-professionali'],
  slug: {
    'it': 'servizi-professionali'
  },
  label: {
    'it': 'Servizi professionali'
  },
  label_plural: {
    'it': 'Servizi professionali'
  },
  order: 12
}, {
  key: 'Laboratorio',
  keys: ['Laboratorio', 'laboratorio'],
  slug: {
    'it': 'laboratorio'
  },
  label: {
    'it': 'Laboratorio'
  },
  label_plural: {
    'it': 'Laboratori'
  },
  order: 13
}, // {
//   key: 'Magazzino',
//   keys: [
//     'Magazzino',
//     'magazzino',
//   ],
//   slug: {
//     'it': 'magazzino',
//   },
//   label: {
//     'it': 'Magazzino',
//   },
//   label_plural: {
//     'it': 'Magazzini',
//   },
//   order: 14,
// },
{
  key: 'Altre attività',
  keys: ['Altre attività', 'altre-attivita'],
  slug: {
    'it': 'altre-attivita'
  },
  label: {
    'it': 'Altre attività'
  },
  label_plural: {
    'it': 'Altre attività'
  },
  order: 15
}, {
  key: 'Negozi',
  keys: ['Negozi', 'negozio'],
  slug: {
    'it': 'negozio'
  },
  label: {
    'it': 'Negozi'
  },
  label_plural: {
    'it': 'Negozi'
  },
  order: 16
}];
exports.license_type_groups_filter = license_type_groups_filter;